module.exports = __webpack_public_path__ + "./fonts/a416dcc22149c490e159f1f15d0cb713.woff";